import React from 'react';
import {
  Box
} from '@mui/material';
import EditSKUMgmt from '../component/sku-mgmt-form/edit/EditSKUMgmt';

function ViewPage({ history, match: { params } }) {
  return (
    <Box>
      <EditSKUMgmt readOnly id={params.id} />
    </Box>
  );
};

export default ViewPage;